import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { CpSpeedTestsComponent } from './cp-speed-tests.component';
import { Authority } from '@app/shared/utils/enums';

export const CpSpeedTestsRoutes: Routes = [
    {
        path: 'cp-speed-tests',
        children: [
            {
                path: '',
                component: CpSpeedTestsComponent,
                data: {
                    authorities: [Authority.ADMIN]
                }
                //,canActivate: [RouteAccessGuard]
            }
        ]
    }
]